export default {"src":"/_next/static/media/band.c1038058.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};